import { CHAT_API_BASE } from '../../config/api';

export async function fetchWithSessionToken(url, options = {}) {
  const token = localStorage.getItem('sessionToken');
  const shopId = localStorage.getItem('shopId');
  const orderId = localStorage.getItem('orderId');
  const storedEmail = localStorage.getItem('userEmail');
  const storedOrderNumber = localStorage.getItem('orderId');

  // Don't add Content-Type header for FormData (multipart requests)
  // The browser will set it automatically with the correct boundary
  const isMultipartRequest = options.body instanceof FormData;
  
  options.headers = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
    shopId: `${shopId}`,
    orderId: `${orderId}`, // ⬅ Include in every secured request
  };
  
  // Remove Content-Type header for multipart requests to let browser set it
  if (isMultipartRequest && options.headers['Content-Type']) {
    delete options.headers['Content-Type'];
  }

  try {
    const response = await fetch(url, options);

    if (response.status === 403 || response.status === 401) {
      // Try to reauthenticate if we have the necessary info
      if (storedEmail && storedOrderNumber && shopId) {
        try {
          // POST the identifiers in the body (not the query string) so the
          // customer's order number / email don't leak into logs or history.
          // Inlined rather than using the shared helper to avoid a circular
          // import (the helper imports this module).
          const authResponse = await fetch(
            `${CHAT_API_BASE}/companies/orders/dynamic`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                companyId: shopId,
                searchParam: storedOrderNumber,
                additionalParam: storedEmail,
              }),
            }
          );

          if (authResponse.ok) {
            const data = await authResponse.json();
            if (data.bearerToken) {
              // Update token and retry original request
              localStorage.setItem('sessionToken', data.bearerToken);
              
              // Retry original request with new token
              options.headers.Authorization = `Bearer ${data.bearerToken}`;
              return fetch(url, options);
            }
          }
        } catch (reauthError) {
          console.error('Reauth failed:', reauthError);
        }
      }

      // If reauthentication failed or wasn't possible, clear tokens
      localStorage.removeItem('sessionToken');
      localStorage.removeItem('orderId');
      localStorage.removeItem('shopId');

      const error = new Error('Unauthorized');
      error.status = response.status;
      throw error;
    }

    return response;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
}
